import { FC } from 'react'

import { Tooltip as ChakraTooltip, IconButton } from '@chakra-ui/react'
import { TransformTypes } from '@editor/interfaces/canvas'
import { useAppDispatch, useAppSelector } from '@editor/store/app'
import { setSelectedTransform } from '@editor/store/tool'
import { Tooltip } from '@infraloop/common'

const SubToolbarButton: FC<{
  icon: React.ReactElement
  label: string
  toolType: TransformTypes
  tooltipPlacement?: Required<ChakraTooltip.RootProps>['positioning']['placement']
  size?: 'sm' | 'md' | 'lg'
  disabled?: boolean
}> = ({ icon, label, toolType, tooltipPlacement = 'bottom', size = 'md', disabled = false }) => {
  const dispatch = useAppDispatch()
  const isSelected = useAppSelector((state) => toolType === state.toolUtil.core.selectedTransform)

  return (
    /* TODO: style migration needed - p=2 */
    /* TODO: style migration needed - fontSize=xs */
    /* TODO: style migration needed - fontWeight=normal */
    <Tooltip showArrow positioning={{ placement: tooltipPlacement }} label={label}>
      <IconButton
        variant="editorGhost"
        aria-label={label}
        position="relative"
        disabled={disabled}
        bgColor={isSelected && !disabled ? 'gray2.600' : undefined}
        color={isSelected && !disabled ? 'white' : 'whiteAlpha.800'}
        _disabled={{
          color: 'whiteAlpha.400',
        }}
        size={size}
        onClick={
          disabled
            ? undefined
            : () => {
                dispatch(setSelectedTransform(toolType))
              }
        }
      >
        {icon}
      </IconButton>
    </Tooltip>
  )
}

export default SubToolbarButton
